// Persona mappers - transform backend-specific persona data to contract types
import type { Persona } from '@/types/domain'
import { getStoredImageFocus, resolveStoredImageUrl } from '@/lib/media/imageAssetFields'
import { getSupabasePublicUrl } from '@/lib/media/supabaseStorageProvider'

interface RawPersona {
  id: string | number;
  imgpath?: string;
  created_at?: string;
  updated_at?: string;
  [key: string]: unknown;
}

export function mapPersonaFromSupabase(raw: RawPersona): Persona {
  const withImage = {
    ...raw,
    imgpath: resolveStoredImageUrl({
      row: raw,
      prefix: 'img',
      fallbackUrl: raw?.imgpath,
      getPublicUrl: getSupabasePublicUrl,
    }),
    img_focus: getStoredImageFocus(raw, 'img'),
  };

  return {
    ...withImage,
    id: Number(withImage.id),
    ...(withImage.created_at && { created_at: withImage.created_at }),
    ...(withImage.updated_at && { updated_at: withImage.updated_at }),
  } as Persona;
}

export function mapPersonasFromSupabase(rawList: RawPersona[]): Persona[] {
  return rawList?.map(mapPersonaFromSupabase) || [];
}
